import { render, staticRenderFns } from "./ConfirmationStepComponent.vue?vue&type=template&id=393f55ab&scoped=true"
import script from "./ConfirmationStepComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmationStepComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationStepComponent.vue?vue&type=style&index=0&id=393f55ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393f55ab",
  null
  
)

export default component.exports